import { can, emp, leaveScope, me, uname } from "./access.js";
import { S, ui } from "../app/store.js";
import { daysTo, fmtD } from "../domain/dates.js";
import { runTot } from "../domain/payroll.js";
import { LEAVE_TYPES } from "../domain/reference.js";
import { depAlerts } from "../features/deployments/page.js";
import { birCalendar } from "../domain/compliance.js";

function inbox() {
  const u = me(),
    items = [];
  if (can("gl.approve"))
    S.je
      .filter((j) => j.status === "DRAFT")
      .forEach((j) =>
        items.push({
          k: "Voucher",
          v: "gl",
          t: `${j.id} · ${j.memo}`,
          s: `Prepared by ${uname(j.by)} · ${fmtD(j.date)}`,
          amt: j.lines.reduce((a, l) => a + l.d, 0),
          own: j.by === u.id,
          act: "jv-post",
          id: j.id,
          label: "Approve & post",
        }),
      );
  if (can("pay.approve"))
    S.runs
      .filter((r) => r.status === "DRAFT")
      .forEach((r) =>
        items.push({
          k: "Payroll",
          v: "payroll",
          t: `${r.id} · ${fmtD(r.from)} – ${fmtD(r.to)}`,
          s: `Prepared by ${uname(r.by)} · ${r.lines.length} employees · net pay`,
          amt: runTot(r).net,
          own: r.by === u.id,
          act: "pr-ok",
          id: r.id,
          label: "Approve",
        }),
      );
  if (can("pay.release"))
    S.runs
      .filter((r) => r.status === "APPROVED")
      .forEach((r) =>
        items.push({
          k: "Payroll",
          v: "payroll",
          t: `Release ${r.id} net pay`,
          s: `Approved by ${uname(r.ap)} · pay date ${fmtD(r.pay)}`,
          amt: runTot(r).net,
          act: "pr-rel",
          id: r.id,
          label: "Release",
        }),
      );
  leaveScope()
    .filter((l) => l.source !== "HRM_PLANT" && l.status === "PENDING")
    .forEach((l) =>
      items.push({
        k: "Leave",
        v: "leave",
        t: `${emp(l.emp).name} · ${LEAVE_TYPES[l.type].split(" (")[0]}`,
        s: `${l.days} day${l.days === 1 ? "" : "s"} from ${fmtD(l.from)} · ${l.reason}`,
        act: "lv-ok",
        id: l.id,
        label: "Approve",
        alt: "lv-no",
      }),
    );
  if (can("dep.manage"))
    depAlerts()
      .filter((a) => a.tone === "bad")
      .forEach((a) =>
        items.push({
          k: "Deployment",
          v: "deploy",
          t: a.t,
          s: a.s,
          tone: "bad",
          act: a.act,
          id: a.id,
          label: a.label,
        }),
      );
  if (can("hr.salary"))
    S.employees
      .filter((e) => e.lic && daysTo(e.lic[2]) <= 60)
      .forEach((e) =>
        items.push({
          k: "License",
          v: "people",
          t: `${e.name} · ${e.lic[0]} ${daysTo(e.lic[2]) < 0 ? "expired" : "expires " + fmtD(e.lic[2])}`,
          s: "Signed and sealed deliverables need a valid PRC license",
          tone: daysTo(e.lic[2]) < 0 ? "bad" : "warn",
        }),
      );
  if (can("bir.file"))
    birCalendar()
      .filter((b) => b.due && !b.filed && daysTo(b.due) <= 14)
      .forEach((b) =>
        items.push({
          k: "BIR",
          v: "bir",
          t: `${b.form} · ${b.per}`,
          s: `Due ${fmtD(b.due)}${daysTo(b.due) < 0 ? " · overdue" : ` · in ${daysTo(b.due)} days`}`,
          amt: b.amt,
          act: "file",
          id: b.k,
          label: "Mark filed",
          tone: daysTo(b.due) <= 3 ? "bad" : "warn",
        }),
      );
  if (can("dep.manage"))
    S.workLogs
      .filter((l) => l.status === "PENDING" && l.by !== ui.user)
      .forEach((l) =>
        items.push({
          k: "Work log",
          v: "worklogs",
          t: `${emp(l.emp)?.name} · ${l.project} · ${l.units} ${l.unit}`,
          s: `${fmtD(l.date)} · submitted by ${uname(l.by)}`,
          id: l.id,
        }),
      );
  S.leaves.filter((l) => l.source === "HRM_PLANT" && l.emp !== u.emp &&
    (["PENDING", "IN_REVIEW"].includes(l.status) && (l.policySnapshot?.steps || ui.hrm?.hrm?.leavePolicies?.find((p) => p.version === l.policyVersion)?.steps)?.[l.step] === u.id ||
     l.status === "PENDING_POLICY" && ui.hrm?.hrm?.activeLeavePolicy?.types?.includes(l.type) && ui.hrm?.hrm?.activeLeavePolicy?.steps?.[0] === u.id))
    .forEach((l) => items.push({ k: "Plant leave", v: "leave", t: `${emp(l.emp)?.name || l.emp} · ${l.type}`, s: `${fmtD(l.from)} – ${fmtD(l.to)} · ${l.status === "PENDING_POLICY" ? "Assign approved policy" : "Configured approval step"}`, id: l.id }));
  return items.filter((i) => !i.own);
}

export { inbox };
